import { render, staticRenderFns } from "./mHeader.vue?vue&type=template&id=0fc97e72&scoped=true&"
import script from "./mHeader.vue?vue&type=script&lang=js&"
export * from "./mHeader.vue?vue&type=script&lang=js&"
import style0 from "./mHeader.vue?vue&type=style&index=0&id=0fc97e72&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc97e72",
  null
  
)

export default component.exports